import React, {useEffect, useState} from "react";
import Header from "../../components/Header.js";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import {
    EVENTS,
    FIREBASE_SCREEN_NAMES,
    HEADER_SIZE,
    LOCALSTORAGE_ITEMS,
    PAYMENT_TYPES,
    procStatuses
} from "../../util/Constants.js";
import loyaltyPointImg from "../../assets/img/loyalty-point.svg";
import loyaltyBackgroundImg from "../../assets/img/loyalty-background.png";
import ThankYouActionsbar from "../../components/Actionsbar/ThankYouActionsbar";
import {
    calculatePercentageDiscount,
    calculateSubtotalPrice,
    findMobileOperatingSystemAndGetLink,
    findReturnable,
    getAppLocale,
    getLastDay,
    getOrderCheckoutMsg,
    getTotalProducts,
    renderProducts,
    sendEvent
} from "../../util/common";
import {PATH} from "../../routes/routes.js";
import analyticsLogEvent from "../../services/FirebaseService";
import iconPhone from "../../assets/img/icon_phone_black.svg"
import iconZoniz from "../../assets/img/icon_zoniz_white.svg";
import BrandingWatermark from "../../components/BrandingWatermark";
import * as ProductService from "../../services/ProductService";
import iconCheckMark from "../../assets/img/icon_checkmark_white.svg";
import {DATE_FORMAT} from "../../util/DateUtil";
import Moment from "react-moment";
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function TableThankYou() {
    const navigateTo = useNavigate();
    const {orderId} = useParams();
    const currency = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).currency:null;
    const shopLanguage = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang:null;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const showDownloadApp = shopDetails ? (typeof shopDetails.merchantConfig.showDownloadApp !== "undefined" ? shopDetails.merchantConfig.showDownloadApp : null) : false;
    const allproductsFromStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS)?JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS)):null;
    const [state, setState] = useState({
        loading: false,
        allOrderProducts: allproductsFromStorage,
        discount:allproductsFromStorage?.discount,
        procStatus:allproductsFromStorage?.procStatus,
        lastMod:allproductsFromStorage?.lastMod,
        paymentMethod:allproductsFromStorage?.paymentMethod,
        tips:allproductsFromStorage?.tips
    });

    useEffect(() => {
        checkIfOrderWasChanged();
        if (state.allOrderProducts==null) {
            navigateTo(PATH.ALL_PRODUCTS);
        }

        sendEvent({
            type: EVENTS.NO_ACTIVE_ORDER,
            body: {
                shopDetails:shopDetails
            }
        });

        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.THANK_YOU,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.THANK_YOU
        });
        let delayDebounceFn = null;
        delayDebounceFn = setInterval(() => {
            checkIfOrderWasChanged();
        }, 10000)
        return () => clearInterval(delayDebounceFn);
    }, []);





    let  loyaltyContainerBg = {
        backgroundImage: 'url(' + loyaltyBackgroundImg + ')',
    };

     async function checkIfOrderWasChanged()  {

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "fromDate": getLastDay(),
            // "procStatus": ["OPEN", "CONFIRMED", "READY", "DELIVERED"]
        }

        const response = await ProductService.getAllProductsOrders(body);
        if (response.ok) {
            let currentOrder = null;
            const storageCurrentOrderId = orderId;
            for(let i=0; i < response.data.orders.length;i++){
                const o = response.data.orders[i];
                if(o.oid === storageCurrentOrderId){
                    currentOrder = o;
                    break;
                }
                if(currentOrder === null && o.procStatus === "OPEN"){
                    currentOrder = o;
                }
            }

            if (currentOrder.lastMod !== state.allOrderProducts?.lastMod)  {
                setState({
                    ...state,
                    procStatus:currentOrder?.procStatus,
                    lastMod:currentOrder?.lastMod,
                    discount: currentOrder?.discount,
                    paymentMethod: currentOrder?.paymentMethod,
                    tips:currentOrder?.tips,
                    allOrderProducts: currentOrder
                })

                StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS, JSON.stringify(currentOrder));
            }
        }
    }

    return (
        <>
            <Header
                headerSize={HEADER_SIZE.SMALL}
                headerTitle={<FormattedMessage id="OrderDetails"/>}
            />

            <main className="page-content thank-you-page-content">
                <div className="container-title">
                    {JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).title}
                </div>
                {shopDetails.data?.phone && <div className="container-phone">
                    <a href={"tel:" + shopDetails.data.phone}>

                    <img src={iconPhone}/>
                        <h3 className="phone">{shopDetails.data.phone}</h3>
                    </a>
                </div>}

                <div className="container-table-and-order-id">
                    <h3 className="faded-text">
                        {StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE)},
                        <FormattedMessage id="OrderNumber"/> {orderId}
                    </h3>
                </div>
                {state.procStatus === procStatuses.DELIVERED && <div className="container-date-and-time">
                    <h3 className="faded-text">
                        <Moment
                            format={DATE_FORMAT.DAY_MONTH_YEAR_HOUR_MINUTES}
                            date={state.lastMod}
                        />
                    </h3>
                </div>}


                <div className="container-waiter-msg">

                    { state.procStatus == procStatuses.CHECKOUT && state.paymentMethod === PAYMENT_TYPES.ONLINE && <div className="text-delivered">
                        <div className="row">
                            <div className="icon-col col">
                                <img className="icon-checkmark" src={iconCheckMark} alt=""/>
                            </div>
                            <div className="col">
                                <h3>
                                    {state.paymentMethod.toLowerCase() === "online" ?
                                        <FormattedMessage id="TheOrderHasBeenPaidOnline"/>
                                        :
                                        <FormattedMessage id="TheOrderHasBeenPaidBy"
                                                          values={{paymentMethod: state.paymentMethod?.toLowerCase()}}/>
                                    }
                                </h3>
                                <h3><FormattedMessage id="WeHopeYouEnjoyedIt"/></h3>
                            </div>
                        </div>

                    </div>}


                    { state.procStatus == procStatuses.CHECKOUT && state.paymentMethod !== PAYMENT_TYPES.ONLINE && <div className="text-checkout">
                    <h3>{getOrderCheckoutMsg()}</h3>
                    {(shopLanguage === "ro" && state.paymentMethod) && <h3><FormattedMessage id="PaymentMethodToTheWaiter"/>&nbsp; ({state.paymentMethod?.toLowerCase()})</h3>}
                    </div>}

                    { state.procStatus == procStatuses.DELIVERED &&
                    <div className="text-delivered">
                        <div className="row">
                            <div className="col icon-col">
                                <img className="icon-checkmark" src={iconCheckMark}/>
                            </div>
                            <div className="col">
                                <h3>
                                    {state.paymentMethod.toLowerCase() === "online" ?
                                        <FormattedMessage id="TheOrderHasBeenPaidOnline"/>
                                        :
                                        <FormattedMessage id="TheOrderHasBeenPaidBy"
                                                          values={{paymentMethod: state.paymentMethod?.toLowerCase()}}/>
                                    }
                                </h3>
                                <h3>{<FormattedMessage id="WeHopeYouEnjoyedIt"/>}</h3>
                            </div>
                        </div>


                    </div>
                    }

                </div>
                <>
                    <div style={loyaltyContainerBg} className="loyalty-container">
                        <div style={{backgroundImage: "url('" + loyaltyPointImg + "')"}} className="loyalty-point-img"></div>
                         <div className="loyalty-text">
                                 {<FormattedMessage id="DownloadTheAppToEarnCampaignPoints"/>}
                             <a target="blank" href={findMobileOperatingSystemAndGetLink()}><img src={iconZoniz}/></a>

                         </div>
                    </div>
                </>
                <div className="order-details-card no-bg">
                    <div className="card-content">
                        {
                            renderProducts(state.allOrderProducts)
                        }

                        {state.discount &&
                        <div className="subtotal-and-discount-container">
                          <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="Subtotal"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={calculateSubtotalPrice(state.allOrderProducts) / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                          </div>
                            <div className={`row discount-row ${findReturnable(state.allOrderProducts.products) ? 'mb-0' : ''}`}>
                                 <span className="subtotal-label">
                                      <FormattedMessage
                                          id="Discount"
                                      />
                                </span>
                                <span className="discount-percentage">
                                    &nbsp;{calculatePercentageDiscount(state.allOrderProducts)}%
                                </span>
                                <span className="total-price">-
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.discount / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>

                            {findReturnable(state.allOrderProducts.products) && <div className="row smaller-txt">
                               <i><FormattedMessage id="DiscountNotAppliedToReturnableExtras"/></i>
                            </div>
                            }

                        </div>
                        }



                        {(state.tips !== null && state.tips > 0) &&
                        <div className="subtotal-and-discount-container">
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="Subtotal"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={calculateSubtotalPrice(state.allOrderProducts, true) / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                    <FormattedMessage id="Tip"/>
                                </span>
                                <span className="total-price"> + &nbsp;
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.tips / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                        </div>
                        }

                        <div className="total-container row">
                            <span className="total-prod-nr">{
                                getTotalProducts(state.allOrderProducts.products)
                            }&nbsp;</span>
                            <span className="total-prod-label">{getTotalProducts(state.allOrderProducts.products) !==1 ?  <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>}</span>
                            <span className="total-price" data-qa="thank-you-total-price">
                                {<FormattedMessage id="Total"/>}&nbsp;
                                 <IntlProvider locale={getAppLocale()}>
                                 <FormattedNumber
                                     value={state.allOrderProducts.price / 100.0}
                                     style="currency"
                                     minimumFractionDigits={2}
                                     maximumFractionDigits={2}
                                     currency={currency} />
                                 </IntlProvider>
                            </span>
                        </div>



                    </div>
                </div>
                <BrandingWatermark/>
            </main>
            <ThankYouActionsbar
                isVisible={true}
                btnClassName={"btn btn-default btn-xl"}
                btnName={<FormattedMessage id="StartNewOrder"/>}
                showDownloadApp={showDownloadApp}
            ></ThankYouActionsbar>

        </>


    );
}

export default TableThankYou;
